var exports = {
  "Vg": "ChatSkeleton.module__grid___THNkam",
  "wx": "ChatSkeleton.module__header___THNkam",
  "D_": "ChatSkeleton.module__identity___THNkam",
  "Ow": "ChatSkeleton.module__identityBack___THNkam",
  "um": "ChatSkeleton.module__identityBackDesktop___THNkam",
  "W": "ChatSkeleton.module__identityName___THNkam",
  "aL": "ChatSkeleton.module__identityCaret___THNkam",
  "lf": "ChatSkeleton.module__identityTopicDivider___THNkam",
  "$s": "ChatSkeleton.module__headerActions___THNkam",
  "QE": "ChatSkeleton.module__headerAction___THNkam",
  "YB": "ChatSkeleton.module__headerSearch___THNkam",
  "lQ": "ChatSkeleton.module__headerSearchIcon___THNkam",
  "Qs": "ChatSkeleton.module__content___THNkam",
  "ec": "ChatSkeleton.module__memberListDivider___THNkam",
  "oM": "ChatSkeleton.module__chatArea___THNkam",
  "JX": "ChatSkeleton.module__chatBody___THNkam",
  "DZ": "ChatSkeleton.module__messages___THNkam",
  "T_": "ChatSkeleton.module__composerInputLine___THNkam",
  "PN": "ChatSkeleton.module__composerAction___THNkam",
  "JD": "ChatSkeleton.module__memberList___THNkam",
  "Pz": "ChatSkeleton.module__memberListScroller___THNkam",
};

module.exports = exports;
